/* eslint-disable default-param-last */
import {
  CLEAR_CURRENT_PERSONALIZATION,
  PERSONALIZATION_ALL,
  PERSONALIZATION_SET_DEFAULT_VIEW,
  PERSONALIZATION_VIEW_OPTION,
  SET_ALL_CAMPAIGN_PERSONALIZATION_DATA,
  SET_PERSONALIZATION,
  SET_PERSONALIZATION_STATUS,
  UPDATE_PERSONALIZATION_API_STATUS,
} from '../types';

const INITIAL_STATE = {
  status: '',
  updatePersonalizatonApiStatus: '',
  viewOption: {},
  clearCurrentPersonalization: false,
  isDefaultTriggeredByUser: false,
  personalizationAll: {
    advancedFilters: null,
    rows: null,
    columns: null,
  },
  campaignPersonalizationData: {},
};

const personalizationReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_PERSONALIZATION_STATUS:
      return {
        ...state,
        status: action.payload,
      };

    case SET_PERSONALIZATION:
      return {
        ...state,
        personalizedData: action.payload,
      };
    case SET_ALL_CAMPAIGN_PERSONALIZATION_DATA:
      return {
        ...state,
        campaignPersonalizationData: action.payload,
      };

    case UPDATE_PERSONALIZATION_API_STATUS:
      return {
        ...state,
        updatePersonalizatonApiStatus: action.payload,
      };

    case PERSONALIZATION_SET_DEFAULT_VIEW:
      return {
        ...state,
        isDefaultTriggeredByUser: action.payload,
      };

    case PERSONALIZATION_VIEW_OPTION:
      return {
        ...state,
        viewOption: action.payload,
      };

    case CLEAR_CURRENT_PERSONALIZATION:
      return {
        ...state,
        clearCurrentPersonalization: action.payload,
      };

    case PERSONALIZATION_ALL:
      return {
        ...state,
        personalizationAll: {
          ...state.personalizationAll,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default personalizationReducer;
